import React, { useEffect, useRef } from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';

const Settings = () => {
  const location = useLocation();
  const isProfile = location.pathname === '/landlord/settings';
  const isChangePassword = location.pathname === '/landlord/settings/change-password';
  const isSubscription = location.pathname === '/landlord/settings/subscription';
  const isCallCredit = location.pathname === '/landlord/settings/call-credit';
  const isBillingUsage = location.pathname === '/landlord/settings/billing-usage';
  const navRef = useRef(null);

  // On phones the nav is a horizontally scrolling tab bar; keep the active tab in view.
  useEffect(() => {
    const nav = navRef.current;
    if (!nav || nav.scrollWidth <= nav.clientWidth) return;
    const active = nav.querySelector('.settings-nav-item.active');
    if (active) nav.scrollLeft += active.getBoundingClientRect().left - nav.getBoundingClientRect().left - 16;
  }, [location.pathname]);

  return (
    <div className="settings-page">
      <div className="settings-content">
        <div className="settings-navigation" ref={navRef}>
          <Link
            to="/landlord/settings"
            className={`settings-nav-item ${isProfile ? 'active' : ''}`}
          >
            <span className="settings-nav-label">Profile</span>
            <img 
              src={window.getPublicUrl ? window.getPublicUrl("/assets/images/ArrorRighticon.svg") : "/assets/images/ArrorRighticon.svg"} 
              alt="arrow" 
              className="settings-nav-arrow-icon"
            />
          </Link>
          <Link
            to="/landlord/settings/change-password"
            className={`settings-nav-item ${isChangePassword ? 'active' : ''}`}
          >
            <span className="settings-nav-label">Change Password</span>
            <img 
              src={window.getPublicUrl ? window.getPublicUrl("/assets/images/ArrorRighticon.svg") : "/assets/images/ArrorRighticon.svg"} 
              alt="arrow" 
              className="settings-nav-arrow-icon"
            />
          </Link>
          <Link
            to="/landlord/settings/subscription"
            className={`settings-nav-item ${isSubscription ? 'active' : ''}`}
          >
            <span className="settings-nav-label">Subscription Detail</span>
            <img 
              src={window.getPublicUrl ? window.getPublicUrl("/assets/images/ArrorRighticon.svg") : "/assets/images/ArrorRighticon.svg"} 
              alt="arrow" 
              className="settings-nav-arrow-icon"
            />
          </Link>
          <Link
            to="/landlord/settings/call-credit"
            className={`settings-nav-item ${isCallCredit ? 'active' : ''}`}
          >
            <span className="settings-nav-label">Call Credit</span>
            <img 
              src={window.getPublicUrl ? window.getPublicUrl("/assets/images/ArrorRighticon.svg") : "/assets/images/ArrorRighticon.svg"} 
              alt="arrow" 
              className="settings-nav-arrow-icon"
            />
          </Link>
          <Link
            to="/landlord/settings/billing-usage"
            className={`settings-nav-item ${isBillingUsage ? 'active' : ''}`}
          >
            <span className="settings-nav-label">Twilio Call Usage</span>
            <img 
              src={window.getPublicUrl ? window.getPublicUrl("/assets/images/ArrorRighticon.svg") : "/assets/images/ArrorRighticon.svg"} 
              alt="arrow" 
              className="settings-nav-arrow-icon"
            />
          </Link>
        </div>

        <Outlet />
      </div>
    </div>
  );
};

export default Settings;
